module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Victor Benavente","slug":"blog/author/victor-benavente","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/victor-benavente"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog-author-victor-benavente.json
// module id = 1423
// module chunks = 137953525537868